// src/pages/pengamatan/sensus-populasi-anakan-pisang/hooks/useFilterControl.js
import { useState } from 'react';

/**
 * Custom hook untuk mengontrol state filter dan toggle icon
 */
export const useFilterControl = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [dateSort, setDateSort] = useState('ascending');

  /**
   * Fungsi untuk toggle filter open/close
   */
  const toggleFilter = () => {
    setIsFilterOpen(prev => !prev);
  };

  /**
   * Fungsi untuk mengubah filter status
   */
  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
  };

  /**
   * Fungsi untuk mengubah sorting tanggal
   */
  const handleDateSortChange = (sort) => {
    setDateSort(sort);
  };

  /**
   * Fungsi untuk reset semua filter
   */
  const resetFilter = () => {
    setStatusFilter('');
    setDateSort('ascending');
    setIsFilterOpen(false);
  };

  /**
   * Fungsi untuk menerapkan filter
   */
  const applyFilter = (orders) => {
    let filtered = [...orders];

    // Filter berdasarkan status
    if (statusFilter) {
      filtered = filtered.filter(order => 
        order.status_pengamatan === statusFilter
      );
    }

    // Sorting berdasarkan tanggal
    filtered.sort((a, b) => {
      if (dateSort === 'ascending') {
        return a.tanggal_pengamatan_sort.localeCompare(b.tanggal_pengamatan_sort);
      } else {
        return b.tanggal_pengamatan_sort.localeCompare(a.tanggal_pengamatan_sort);
      }
    });

    return filtered;
  };

  return {
    isFilterOpen,
    statusFilter,
    dateSort,
    toggleFilter,
    handleStatusFilterChange,
    handleDateSortChange,
    resetFilter,
    applyFilter
  };
};

export default useFilterControl;